export const WEEKLY_FOOTFALL_MAX_VALUE = 250000;

export const FEATURED_LIST = [
  { value: "new", label: "New" },
  process.env.NEXT_PUBLIC_APP_WL_CODE === "LOCL" && { value: "trending_locations", label: "Trending locations" },
  { value: "iconic_backdrop", label: "Iconic backdrops" },
].filter(Boolean) as { value: string; label: string }[];

export const AGE_RANGE_OPTIONS = [
  {
    value: [null, null],
    title: "% of Gen Z (16 - 24 yrs)",
    key: "gen_z__range",
    apiKey: "genZ"
  },
  {
    value: [null, null],
    title: "% of Gen Y (25 - 39 yrs)",
    key: "gen_y__range",
    apiKey: "genY"
  },
  {
    value: [null, null],
    title: "% of Gen X (49 - 58 yrs)",
    key: "gen_x__range",
    apiKey: "genX"
  },
  {
    value: [null, null],
    title: "% of Gen BB (59 - 74 yrs)",
    key: "baby_boomer__range",
    apiKey: "babyBoomer"
  },

];

export const TARGET_AUDIENCE_OPTIONS = [
  {
    value: [null, null],
    title: "Weekly footfall",
    key: "weekly_footfall__range",
    apiKey: "weeklyFootfall"
  },
  {
    value: [null, null],
    title: "Avg. spend/visit",
    key: "spending__range",
    apiKey: "spending"
  },
  {
    value: [null, null],
    title: "Avg. dwell time/visit",
    key: "dwell_time__range",
    apiKey: "dwellTime"
  },
  {
    value: [null, null],
    title: "ABC1%",
    key: "abc1__range",
    apiKey: "abc1"
  },
];

const parserFunction = (value?: string) => {
  const newVar = value?.match(/\b\d+(\.\d+)?\b/g) || [];

  return +newVar.join("");
};

export const mapInputNumberProps = (key: string, currencySymbol: string) => {
  switch (key) {
    case "spending":
    case "rate_daily__range":
      return {
        formatter: (value?: string) => `${currencySymbol} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        parser: parserFunction,
      };
    case "dwellTime":
      return {
        formatter: (value?: string) => `${value} min`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        parser: parserFunction
      };
    case "weeklyFootfall":
      return {
        formatter: (value?: string) => `${+(value as string) >= WEEKLY_FOOTFALL_MAX_VALUE ? "+" : ""}${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        parser: parserFunction,
      };
    case "abc1":
    case "genZ":
    case "genY":
    case "genX":
    case "babyBoomer":
    case "female__range":
    case "male__range":
      return {
        formatter: (value?: string) => `${value}%`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        parser: parserFunction
      };
    default:
      return {};
  }
};

export const checkParamsIsEmpty = ({
  params,
  setIsShowClear
}: {
  params: Record<string, unknown>;
  setIsShowClear: (value: boolean) => void;
}) => {
  let isEmpty = true;

  const currentParams = { ...params };

  if (
    currentParams.popular_searches__in ||
    currentParams.male__range ||
    currentParams.female__range ||
    currentParams.collections__in ||
    currentParams.rate_daily__range ||
    currentParams.except_facet ||
    currentParams.new ||
    currentParams.trending_locations ||
    currentParams.iconic_backdrop
  ) {
    isEmpty = false;
  }

  [...AGE_RANGE_OPTIONS, ...TARGET_AUDIENCE_OPTIONS].forEach((val) => {
    if (currentParams[val.key]) {
      isEmpty = false;
    }
  });

  if (isEmpty) {
    setIsShowClear(false);
  } else {
    setIsShowClear(true);
  }
};
